// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAceur } from "../../../icons/full/build/icon-aceur.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AceurIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAceur.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AceurIcon.displayName = 'AceurIcon';
}

export default AceurIcon;